import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,[_c('h1',{staticClass:"mb-3"},[_vm._v("Sparkl Reusables Admin Panel")]),_c('p',[_vm._v("Welcome to the Admin Panel")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }